
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Product1 from '../Img/Product1.png'
import Product2 from '../Img/Product2.png'
import Product3 from '../Img/Product3.png'
import Product4 from '../Img/Product4.png'
import Product5 from '../Img/Product5.png'
import Product6 from '../Img/Product6.png'
import { useEffect, useRef } from 'react';
import { useState } from 'react';
import { toast } from 'react-toastify';
import Skeleton from 'react-loading-skeleton';
import { ChevronLeft, ChevronLeftCircle, ChevronRight, ChevronRightCircle, ChevronRightCircleIcon } from 'lucide-react';

const NewArrival = ({ cartItemsLength, setCartItemLength, fetchCart, cartButtons }) => {
    const navigate = useNavigate();
    const url = process.env.REACT_APP_API_URL
    const [variationModalData, setVariationModalData] = useState(null);
    const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || null; // Decrypt cookie data
    const isLoggedIn = !!userData?.user_id;
    const scrollContainerRef = useRef();
    const [isScrollable, setIsScrollable] = useState(false);
    const [scrollStates, setScrollStates] = useState([]);
    const containerRefs = useRef([]);
    const [arrivalCategories, setArrivalCategories] = useState([]);
    const [selectedGroupedProduct, setSelectedGroupedProduct] = useState(null);


    const [products, setProducts] = useState([]);
    const [categoryData, setCategoryData] = useState({ category_name: "", description: "" });

    // const sliderFetch = async () => {
    //     try {
    //         const response = await fetch(`${url}/newarrival/all/${process.env.REACT_APP_PERFUME_ID}`);
    //         const res = await response.json();

    //         if (res.length > 0) {
    //             const category = res[0];

    //             const parseSafe = (value, fallback = []) => {
    //                 try {
    //                     return typeof value === "string" ? JSON.parse(value) : (value || fallback);
    //                 } catch {
    //                     return fallback;
    //                 }
    //             };

    //             const parsedProducts = (typeof category.product === "string"
    //                 ? JSON.parse(category.product)
    //                 : category.product
    //             ).map(product => ({
    //                 ...product,
    //                 variation: parseSafe(product.variation),
    //                 gallery: parseSafe(product.gallery),
    //                 key_features: parseSafe(product.key_features),
    //                 specifications: parseSafe(product.specifications),
    //                 attribute: parseSafe(product.attribute),
    //                 downloadable_files: parseSafe(product.downloadable_files),
    //             }));

    //             setTimeout(() => {
    //                 const el = scrollContainerRef.current;
    //                 if (el) setIsScrollable(el.scrollWidth > el.clientWidth);
    //             }, 100); // Delay to allow rendering

    //             setProducts(parsedProducts);
    //             setCategoryData({
    //                 category_name: category.category_name,
    //                 description: category.description
    //             });
    //         }
    //     } catch (error) {
    //         console.log("Slider fetch error:", error);
    //         toast.error("Failed to load New Arrivals.");
    //     }
    // };

    const getDefaultCartButton = () => {
        const isGetQuoteDefault = cartButtons.find(b => b.button_id === 'getquote' && b.default);
        if (isGetQuoteDefault) return 'getquote';

        const isAddToCartDefault = cartButtons.find(b => b.button_id === 'addtocart' && b.default);
        if (isAddToCartDefault) return 'addtocart';

        const isBuyNowDefault = cartButtons.find(b => b.button_id === 'buynow' && b.default);
        if (isBuyNowDefault) return 'buynow';

        return null; // fallback
    };
    const defaultButton = getDefaultCartButton();
    const sliderFetch = async () => {
        try {
            const response = await fetch(`${url}/newarrival/all/${process.env.REACT_APP_PERFUME_ID}`);
            const res = await response.json();

            const parseSafe = (value, fallback = []) => {
                try {
                    return typeof value === "string" ? JSON.parse(value) : (value || fallback);
                } catch {
                    return fallback;
                }
            };

            const parsed = res.map(category => {
                const parsedProducts = (typeof category.product === "string"
                    ? JSON.parse(category.product)
                    : category.product
                ).map(product => ({
                    ...product,
                    variation: parseSafe(product.variation),
                    gallery: parseSafe(product.gallery),
                    key_features: parseSafe(product.key_features),
                    specifications: parseSafe(product.specifications),
                    attribute: parseSafe(product.attribute),
                    downloadable_files: parseSafe(product.downloadable_files),
                }));

                return {
                    ...category,
                    parsedProducts
                };
            });

            setArrivalCategories(parsed);
        } catch (error) {
            console.log("Slider fetch error:", error);
            toast.error("Failed to load New Arrivals.");
        }
    };




    const handleAddToCart = async (productId) => {
        const res = await fetch(`${url}/grouped-product/single/${productId}`);
        const latestProduct = await res.json();

        if (latestProduct.product_type === "Variable Product") {
            const safeVariation = typeof latestProduct.variation === "string"
                ? JSON.parse(latestProduct.variation)
                : latestProduct.variation || [];

            setVariationModalData({ ...latestProduct, variation: safeVariation });
        } else {
            addProductToCart(latestProduct, latestProduct);
        }

    };


    const syncCartItemsWithLatestProducts = async () => {
        const cartItems = JSON.parse(localStorage.getItem('guest_cart')) || [];

        const updatedCart = await Promise.all(cartItems.map(async (item) => {
            try {
                const res = await fetch(`${url}/grouped-product/single/${item.product_id}`);
                const latest = await res.json();

                return {
                    ...item,
                    product_id: latest.product_id,
                    product_name: latest.title,
                    product_price: latest.originalPrice,
                    product_saleprice: latest.discountPrice,
                    product_stockstatus: latest.stock,
                    product_status: latest.status,
                    product_image: latest.image,
                    product_gallery: latest.gallery || [],
                };
            } catch (e) {
                console.error("Sync error:", e);
                return item;
            }
        }));

        localStorage.setItem('guest_cart', JSON.stringify(updatedCart));
    };

    const addProductToCart = async (variation, baseProduct = null) => {
        const item = {
            product_id: variation.product_id || baseProduct?.product_id,
            product_sku: variation.sku || baseProduct?.sku,
            product_name: baseProduct?.title || variation.title,
            product_price: variation.price || baseProduct?.originalPrice,
            product_saleprice: variation.salePrice || baseProduct?.discountPrice,
            product_stockstatus: variation.stock || baseProduct?.stock,
            product_status: baseProduct?.status || 'Active',
            product_image: variation.imageUrl || baseProduct?.image,
            product_gallery: baseProduct?.gallery || [],
            description: baseProduct?.description || "",
            short_description: baseProduct?.short_description || "",
            category: baseProduct?.category || "",
            product_type: baseProduct.product_type,
            variation_attributes: variation.attributes || {},
            typeofsimple: '',
            user_id: userData?.user_id || null,
            user_name: userData?.name || null,
            delivery_days: baseProduct.delivery_days || "",
            main_id: process.env.REACT_APP_PERFUME_ID,
        };

        if (isLoggedIn) {
            try {
                const response = await fetch(`${url}/cart`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(item),
                });

                const result = await response.json();

                if (!response.ok || result.isError) {
                    toast.warn(result.msg || "Product already in cart");
                    return false;
                } else {
                    await fetchCart(userData?.user_id);
                    toast.success("Added to cart");
                    return true;
                }
            } catch (error) {
                console.error("Add to cart error:", error);
                toast.error("Something went wrong");
            }
        } else {
            const existing = JSON.parse(localStorage.getItem('guest_cart')) || [];
            if (existing.some(p => p.product_id === item.product_id)) {
                toast.warn("Product already in cart");
                return false;
            }
            const updatedCart = [...existing, item];
            localStorage.setItem('guest_cart', JSON.stringify(updatedCart));
            toast.success("Added to cart");
            setCartItemLength(updatedCart.length);
            return true;
        }
    };


    const handleProductClick = (id, name) => {
        // navigate(`/product/${name}/${id}`);
        const encryptedName = btoa(encodeURIComponent(name));
        const encryptedId = btoa(encodeURIComponent(id));

        navigate(`/product/${encryptedName}/${encryptedId}`);



    };

    const handleBuyNow = async (productId) => {
        const res = await fetch(`${url}/grouped-product/single/${productId}`);
        const latestProduct = await res.json();

        if (latestProduct.product_type === "Variable Product") {
            const safeVariation = typeof latestProduct.variation === "string"
                ? JSON.parse(latestProduct.variation)
                : latestProduct.variation || [];

            setVariationModalData({ ...latestProduct, variation: safeVariation });
        } else {
            handleBuyCart(latestProduct, latestProduct);
        }

    };

    const handleBuyCart = (variation, baseProduct = null) => {
        const item = {
            product_id: variation.product_id || baseProduct?.product_id,
            product_sku: variation.sku || baseProduct?.sku,
            product_name: baseProduct?.title || variation.title,
            product_price: Number(variation.price) || baseProduct?.originalPrice,
            product_saleprice: Number(variation.salePrice) || baseProduct?.discountPrice,
            product_stockstatus: variation.stock || baseProduct?.stock,
            product_status: baseProduct?.status || 'Active',
            product_image: variation.imageUrl || baseProduct?.image,
            product_gallery: baseProduct?.gallery || [],
            description: baseProduct?.description || "",
            short_description: baseProduct?.short_description || "",
            category: baseProduct?.category || "",
            product_type: baseProduct.product_type,
            variation_attributes: variation.attributes || {},
            typeofsimple: '',
            user_id: userData?.user_id || null,
            user_name: userData?.name || null,
            delivery_days: baseProduct.delivery_days || "",
            main_id: process.env.REACT_APP_PERFUME_ID,
        };

        const products = [item]
        let discount = 0
        const totalSalePrice = products.reduce((acc, p) => acc + Number(p.product_saleprice), 0);
        const totalBeforeDiscount = products.reduce((acc, p) => acc + Number(p.product_price), 0);
        const totalAfterDiscount = (totalSalePrice - discount).toFixed(2);

        const checkoutDetails = {
            products,
            totalBeforeDiscount: totalBeforeDiscount,
            totalAfterDiscount,
        };

        localStorage.setItem("checkout_data", JSON.stringify(checkoutDetails));
        navigate("/checkout")
    }


    const scroll = (index, direction) => {
        const container = containerRefs.current[index];
        const scrollAmount = 300;

        if (container) {
            container.scrollBy({
                left: direction === "left" ? -scrollAmount : scrollAmount,
                behavior: "smooth",
            });
        }
    };

    useEffect(() => {
        sliderFetch();
        syncCartItemsWithLatestProducts();
    }, []);

    useEffect(() => {
        const updateScrollStates = () => {
            const newStates = containerRefs.current.map((ref) => {
                if (!ref) return { left: false, right: false };
                return {
                    left: ref.scrollLeft > 0,
                    right: ref.scrollWidth > ref.clientWidth + ref.scrollLeft,
                };
            });
            setScrollStates(newStates);
        };

        // Add event listeners to each scroll container
        containerRefs.current.forEach((ref, index) => {
            if (ref) {
                ref.addEventListener("scroll", updateScrollStates);
            }
        });

        updateScrollStates(); // Initial check

        return () => {
            // Cleanup listeners
            containerRefs.current.forEach((ref) => {
                if (ref) {
                    ref.removeEventListener("scroll", updateScrollStates);
                }
            });
        };
    }, [arrivalCategories]); // Make sure this runs after categories render


    return (
        <>
            {arrivalCategories.map((cat, index) => (
                <div className="new-arrival">
                    {/* Title & Description */}
                    <motion.h2
                        className="section-title"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        {cat?.category_name}
                    </motion.h2>

                    <motion.p
                        className="section-description"
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2, duration: 0.6 }}
                    >
                        {cat?.description}
                    </motion.p>

                    {/* Products List */}
                    <div className="product-scroll-container">
                        {/* Left Scroll Button (Desktop only) */}
                        {/* <button className="scroll-button left" onClick={() => scroll('left')}>
                    <i className="fas fa-chevron-left"></i>
                </button> */}
                        {scrollStates[index]?.left && (
                            <button
                                className="category-images-scroll-chevron category-images-scroll-chevron-left"
                                onClick={() => scroll(index, "left")}
                            >
                                <ChevronLeft size={28} />
                            </button>
                        )}

                        {scrollStates[index]?.right && (
                            <button
                                className="category-images-scroll-chevron category-images-scroll-chevron-right"
                                onClick={() => scroll(index, "right")}
                            >
                                <ChevronRight size={28} />
                            </button>
                        )}

                        <div className="product-scroll-wrapper" id="productScroll"
                            ref={(el) => (containerRefs.current[index] = el)}>
                            {cat.parsedProducts.map((product, index) => (
                                <motion.div
                                    key={product.product_id}
                                    className="product-card"
                                    initial={{ opacity: 0, scale: 0.9 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    transition={{ delay: index * 0.2, duration: 0.6 }}
                                >
                                    {/* Product Card Content */}
                                    <div className="product-img-wrapper">
                                        {
                                            product.image ? <img onClick={() => handleProductClick(product.product_id, product.title)}

                                                src={`${url}${product.image}`}
                                                alt={product.title}
                                                className="product-img"
                                            /> : <Skeleton onClick={() => handleProductClick(product.product_id, product.title)} height={250} width="100%" style={{ borderRadius: '8px' }} />
                                        }

                                        {/* <div className="overlay">
                                            {defaultButton === 'addtocart' && (
                                                <button className="add-to-cart" onClick={() => handleAddToCart(product.product_id)}><i className="fas fa-shopping-cart" /> Add to Cart</button>
                                            )}
                                            {defaultButton === 'buynow' && (
                                                <button className="add-to-cart" onClick={() => handleBuyNow(product.product_id)}><i className="fas fa-bolt" />Buy Now</button>
                                            )}
                                            {defaultButton === 'getquote' && (
                                                <button className="add-to-cart" onClick={() => handleProductClick(product.product_id, product.title)}><i className="fas fa-eye" />View</button>
                                            )}
                                        </div> */}
                                    </div>

                                    <h3 onClick={() => handleProductClick(product.product_id, product.title)} className="product-title">{product.title}</h3>
                                    <div className="product-pricing" onClick={() => handleProductClick(product.product_id, product.title)}>
                                        <span className="discount-price-card">
                                            ₹{product.product_type === "Variable Product"
                                                ? Math.min(...product.variation.map(v => Number(v.salePrice || v.price)))
                                                : product.discountPrice}
                                        </span>
                                        <span className="original-price-card">
                                            ₹{product.product_type === "Variable Product"
                                                ? Math.min(...product.variation.map(v => Number(v.price)))
                                                : product.originalPrice}
                                        </span>
                                    </div>
                                    <div className="product-action-buttons">
                                        {/* Default Cart Action Buttons */}
                                        {defaultButton === 'addtocart' && (
                                            <div
                                                className="product-add-to-cardt-mobile"
                                                onClick={() => handleAddToCart(product.product_id)}
                                            >
                                                <button>
                                                    <i className="fas fa-shopping-cart" style={{ marginRight: "5px" }}></i>
                                                    Add to Cart
                                                </button>
                                            </div>
                                        )}

                                        {defaultButton === 'buynow' && (
                                            <div
                                                className="product-add-to-cardt-mobile"
                                                onClick={() => handleBuyNow(product.product_id)}
                                            >
                                                <button>
                                                    <i className="fas fa-bolt" style={{ marginRight: "5px" }}></i>
                                                    Buy Now
                                                </button>
                                            </div>
                                        )}

                                        {defaultButton === 'getquote' && (
                                            <div
                                                className="product-add-to-cardt-mobile"
                                                onClick={() => handleProductClick(product.product_id, product.title)}
                                            >
                                                <button>
                                                    <i className="fas fa-eye" style={{ marginRight: "5px" }}></i>
                                                    View
                                                </button>
                                            </div>
                                        )}

                                        {/* Product Type Specific Buttons */}
                                        {product.product_type === "Grouped Product" && (
                                            <div className="group-product-buttons">
                                                <button
                                                    className="group-product-btn-outline"
                                                    onClick={() => setSelectedGroupedProduct(product)}
                                                >
                                                    View Details
                                                </button>
                                                <button
                                                    className="group-product-btn-primary"
                                                    onClick={() => handleAddToCart(product.product_id)}
                                                >
                                                    Select Package
                                                </button>
                                            </div>
                                        )}

                                        {product.product_type === "Variable Product" && (
                                            <div className="group-product-buttons">
                                                <button
                                                    className="group-product-btn-primary"
                                                    onClick={() => handleAddToCart(product.product_id)}
                                                >
                                                    Select
                                                </button>
                                            </div>
                                        )}

                                        {product.product_type !== "Grouped Product" &&
                                            product.product_type !== "Variable Product" && (
                                                <div className="group-product-buttons">
                                                    <button
                                                        className="group-product-btn-primary"
                                                        onClick={() => handleAddToCart(product.product_id)}
                                                        disabled={product.totalStock === 0 || !product.totalStock}
                                                    >
                                                        {product.totalStock === 0 || !product.totalStock
                                                            ? 'Out of Stock'
                                                            : 'Add to Cart'}
                                                    </button>
                                                </div>
                                            )}
                                    </div>
                                </motion.div>
                            ))}
                        </div>

                        {/* Right Scroll Button (Desktop only) */}
                        {/* <button className="scroll-button right" onClick={() => scroll('right')}>
                    <i className="fas fa-chevron-right"></i>
                </button> */}

                    </div>

                    {variationModalData && (
                        <VariationModal
                            product={variationModalData}
                            onClose={() => setVariationModalData(null)}
                            cartButtons={cartButtons}
                            onAddToCart={async (variation) => {
                                const success = await addProductToCart(variation, variationModalData);
                                if (success) {
                                    setVariationModalData(null);
                                }
                            }}
                            onAddToBuyNow={async (variation) => {
                                const success = await handleBuyCart(variation, variationModalData);
                                if (success) {
                                    setVariationModalData(null); // ✅ Only close if added
                                }
                            }
                            }
                        />
                    )}

                    {selectedGroupedProduct && (() => {
                        const groupedItems = selectedGroupedProduct.grouped_product
                            ? JSON.parse(selectedGroupedProduct.grouped_product)
                            : [];


                        return (
                            <motion.div className="group-modal-overlay" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                                <motion.div className="grouped-modal-content" initial={{ y: -50 }} animate={{ y: 0 }}>
                                    <div className="group-modal-header">
                                        <h2>{selectedGroupedProduct.title}</h2>
                                        <button onClick={() => setSelectedGroupedProduct(null)} className="group-modal-close">
                                            <i className="fa fa-times" />
                                        </button>
                                    </div>

                                    <div className="group-modal-body">
                                        {groupedItems.length > 0 && (
                                            <>
                                                <div className="grouped-items-list">
                                                    {groupedItems.map((item, idx) => (
                                                        <div key={idx} className="grouped-item-card">
                                                            <img
                                                                src={`${url}${item.image}`}
                                                                alt={item.title}
                                                                className="grouped-item-image"
                                                            />
                                                            <div className="grouped-item-details">
                                                                <p className="grouped-item-title">{item.title}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>

                                            </>
                                        )}
                                    </div>
                                    {/* <p className='customization-text'>For any customization contact on whatsapp</p> */}
                                    <div className="group-modal-footer">
                                        <button
                                            className="grouped-product-btn-primary"
                                            onClick={() => {
                                                handleAddToCart(selectedGroupedProduct.product_id);
                                                setSelectedGroupedProduct(null);
                                            }}
                                        >
                                            Select Package
                                        </button>
                                    </div>

                                </motion.div>
                            </motion.div >
                        );
                    })()}

                </div>
            ))}
        </>
    );
};


const VariationModal = ({ product, onClose, onAddToCart, cartButtons, onAddToBuyNow }) => {
    const url = process.env.REACT_APP_API_URL
    const getDefaultCartButton = () => {
        const isGetQuoteDefault = cartButtons.find(b => b.button_id === 'getquote' && b.default);
        if (isGetQuoteDefault) return 'getquote';

        const isAddToCartDefault = cartButtons.find(b => b.button_id === 'addtocart' && b.default);
        if (isAddToCartDefault) return 'addtocart';

        const isBuyNowDefault = cartButtons.find(b => b.button_id === 'buynow' && b.default);
        if (isBuyNowDefault) return 'buynow';

        return null; // fallback
    };

    const defaultButton = getDefaultCartButton();
    return (
        <motion.div className="modal-overlay" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
            <motion.div className="variation-modal" initial={{ y: -50 }} animate={{ y: 0 }}>
                <div className="modal-header">
                    <h2>{product.title} - Choose a Variation</h2>
                    <button className="modal-close" onClick={onClose}><i className="fa fa-times" /></button>
                </div>

                <div className="variation-flex-container">
                    {(Array.isArray(product.variation) ? product.variation : []).map((v, idx) => (
                        <div key={idx} className="variation-flex-card">
                            <img src={`${url}${v.imageUrl}`} alt={v.sku} />
                            <div className="variation-info">
                                <p><strong>SKU:</strong> {v.sku}</p>
                                <p><strong>Price:</strong> ₹{v.price}</p>
                                {v.salePrice && <p><strong>Sale:</strong> ₹{v.salePrice}</p>}
                                <p><strong>Stock:</strong> {v.stock}</p>
                                {defaultButton === 'addtocart' && (
                                    <button onClick={() => onAddToCart(v)} className="add-cart-btn">
                                        Add to Cart
                                    </button>
                                )}
                                {defaultButton === 'buynow' && (
                                    <button onClick={() => onAddToBuyNow(v)} className="add-cart-btn">
                                        Buy Now
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </motion.div>
        </motion.div>
    );
};

export default NewArrival;
